

export const POLLING_INTERVAL = 20000;